import { render, staticRenderFns } from "./NavBarTournamentButton.vue?vue&type=template&id=ee91d57e&scoped=true&"
import script from "./NavBarTournamentButton.vue?vue&type=script&lang=js&"
export * from "./NavBarTournamentButton.vue?vue&type=script&lang=js&"
import style0 from "./NavBarTournamentButton.vue?vue&type=style&index=0&id=ee91d57e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee91d57e",
  null
  
)

export default component.exports